import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash'

// Inputs
import { TextInputField, Button, MultiSelectField } from '../helpers';
import { FileUpload } from 'primereact/fileupload';
import Loading from './Loading';
import { Dialog } from "primereact/dialog";
import { TextAreaField } from "../helpers"

// validation
import { CompanyBankValidationSchema, companyBankInitialState } from '../validation/companyBankValidation';

// utils
import { validateInputs } from '../utils';

// redux
import { raiseToast } from '../services/redux/reducers/toast/toast';

// apis
import { uploadFile } from '../services/api/company';

import { getPMCompanyConfig } from '../setup/pmCompanyConfig';


const AddBankAccount = (props) => {
    const { companyData } = props
    const dispatch = useDispatch()

    const [bankAccount, setBankAccount] = useState(companyBankInitialState)
    const [formErrors, setFormErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [visibleApprovalRemarks, setVisibleApprovalRemarks] = useState(false)
    const [bankAccountApprovalRemarks, setBanckAccountApprovalRemarks] = useState('')

    const userDetails = useSelector((state) => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)


    useEffect(() => {
        if(props.companyBranches.length > 0){
            const companyBranchIds = _.uniqBy(props.companyBranches, 'branchId').map(obj => obj.branchId)
            setBankAccount({...companyBankInitialState, branchId: companyBranchIds})
        }
    }, [props.companyBranches])

    const handleBankAccountChange = (event) => {

        if (event.target.name === "branchId") {
            if (event.target.value.length === 0) {
                bankAccount[event.target.name] = null
            }else{
                bankAccount[event.target.name] = event.target.value
            }
        }else if(event.target.name === "ifscCode"){
            bankAccount[event.target.name] = event.target.value?.toUpperCase()
        }else{
            bankAccount[event.target.name] = event.target.value
        }

        setBankAccount({ ...bankAccount })
    }

    const saveBankAccountDetails = async () => {
        const validation_res = await validateInputs(CompanyBankValidationSchema, {...bankAccount, isInternational: pmCompanyConfig.isInternational})
        console.log("validation-response", validation_res)
        if (validation_res.error) {
            setFormErrors(validation_res.error)
        } else {
            setFormErrors({})
            setBankAccount({...validation_res.result})

            if (!validation_res.result?.documentProof) {
                return dispatch(raiseToast({ severity: 'warn', detail: "Please upload bank document proof", life: 3000 }))
            }
            
            if([2,3].includes(companyData.buyerSeller)){
                setVisibleApprovalRemarks(true)
            }
            else{
                props.insertBankAccount(validation_res.result)
            }
        }
    }

    const handleSubmitBankAccountWithApproval = async() => {
        if (!bankAccountApprovalRemarks || (bankAccountApprovalRemarks && bankAccountApprovalRemarks?.trim() === '')){
            return dispatch(raiseToast({ severity: 'warn', detail: "Enter remarks for bank account approval", life: 3000 }))
        }

        props.insertBankAccount({...bankAccount, bankAccountApprovalRemarks})
    }

    const fileUploadHandler = ({ files, options }, doc_name) => {
        const [file] = files;
        const fileReader = new FileReader();
        if (file.size > 5242880) {
            options.clear()
            return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: 'File size exceeds 5MB', life: 3000 }))
        }
        fileReader.onload = (e) => {
            uploadBankAccountDocument(doc_name, file.name, e.target.result, options.props.name);
        };
        fileReader.readAsDataURL(file);
        options.clear()
    };

    const uploadBankAccountDocument = async (doc_name, file_name, data_uri, input_name) => {
        let data = {
            doc_name,
            file_name,
            data_uri
        }

        setIsLoading(true)
        let response = await uploadFile(data)

        if (response) {
            bankAccount[input_name] = response.data
            setBankAccount({ ...bankAccount })
            setIsLoading(false)
        }
    }

    const removeBankDocument = (event) => {
        event.stopPropagation();
        bankAccount.documentProof = ""
        setBankAccount({ ...bankAccount })
    }

    const handleKeyDown = (e) => {
        const regex = /^[A-Z0-9 ]+$/i
        if (!regex.test(e.key)) {
            e.preventDefault()
        }
    }


    return (
        <div className="">
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-6">
                    <TextInputField name="bankName" labelText="Bank Name" value={bankAccount.bankName} maxLength={100} onChange={handleBankAccountChange} errorMessage={formErrors.bankName} required />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6">
                    <TextInputField name="holderName" labelText="Holder Name" value={bankAccount.holderName} maxLength={100} onChange={handleBankAccountChange} errorMessage={formErrors.holderName} required />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6">
                    <TextInputField name="accNo" labelText="Account No" type = "password" preventCopy preventCut preventPaste value={bankAccount.accNo} maxLength={20} onChange={handleBankAccountChange} errorMessage={formErrors.accNo} required />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6">
                    <TextInputField name="confirmAccountNo" labelText="Confirm Account No" preventCopy preventCut preventPaste value={bankAccount.confirmAccountNo} maxLength={20} onChange={handleBankAccountChange} errorMessage={formErrors.confirmAccountNo} required />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6 ">
                    <TextInputField name="ifscCode" labelText={pmCompanyConfig.bankAccountCode} value={bankAccount.ifscCode} maxLength={11} onChange={handleBankAccountChange} onKeyDown={(e) => handleKeyDown(e)} errorMessage={formErrors.ifscCode} required />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6">
                    <MultiSelectField name="branchId" labelText="Company Branch" options={props.companyBranches} optionLabel="branchName" optionValue="branchId" value={bankAccount.branchId} onChange={handleBankAccountChange} errorMessage={formErrors.branchId} required />
                </div>

                <div className="grid upload-file mt-2">
                    <div className="mx-2 flex align-items-center col-12 mb-2">
                        <label htmlFor="bankDocument" className="text-xs mb-1 mr-2">Bank Document<span style={{ color: "red" }} className="from-required">*</span> : </label>
                        {
                            !bankAccount.documentProof ?
                                <div>
                                    <FileUpload mode="basic" name="documentProof" accept=".jpg,.jpeg,.png,.pdf" customUpload uploadHandler={(files) => fileUploadHandler(files, "BANK_DOCUMENT")} auto chooseLabel="Upload Document" />
                                </div>
                                :
                                <div>
                                    <a href={bankAccount.documentProof} className="view-btn" target="_blank">View</a>
                                    <a className="remove-btn" name="remove_bank_document" onClick={(event) => removeBankDocument(event)} >Remove</a>
                                </div>
                        }
                    </div>
                </div>
            </div>
            <div className='mt-3 flex justify-content-end'>
                <Button className="small-btn" label="Add Bank Account" onClick={saveBankAccountDetails} />
            </div>
            <Dialog header={"Approval Remarks"} className='mb-3 approval-remark-dialog' visible={visibleApprovalRemarks} onHide={() => setVisibleApprovalRemarks(false)}>
                <TextAreaField name="bankAccountApprovalRemarks" className="mb-3" labelText="Enter remarks for bank account approval" value={bankAccountApprovalRemarks} rows={3} onChange={e => setBanckAccountApprovalRemarks(e.target.value)} />
                <div className='flex flex-row justify-content-end'>
                    <Button className="mt-2" label="SUBMIT" outlined onClick={() => handleSubmitBankAccountWithApproval()} />
                </div>
            </Dialog>
            <Loading visible={isLoading} />
        </div>
    );
};

export default AddBankAccount;